import { get } from "../api/apiClient";
import { authHeader } from "../api/authHeader";

const API_PREFIX = "/evaluationImplement";

export const init = async () => {
  const response = await get(`${API_PREFIX}/`, authHeader());
  console.log("response", response);
  return response.data;
};

export const search = async request => {
  console.log("request", request);
  var requestUrl =
    "?serialNumber=" +
    request.serialNumber +
    "&grade=" +
    request.grade +
    "&classNumber=" +
    request.class +
    "&number=" +
    request.number +
    "&name=" +
    request.name +
    "&listId=" +
    request.listId +
    "&termId=" +
    request.termId +
    "&implementationFlg=" +
    request.implementationFlg;

  const response = await get(`${API_PREFIX}/search${requestUrl}`, authHeader());
  console.log("response", response);
  return response.data;
};
